module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p36",
      "title": "36"
    }
  }, [_c('p', {
    staticClass: "icon"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("[")]), _vm._v(" QUICK PREP "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("]")])]), _vm._v(" "), _c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "impossibly_easy_mini_breakfast_sausage_pies"
    }
  }, [_vm._v("Impossibly Easy Mini Breakfast Sausage Pies")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("6 servings (2 mini pies each)")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 15 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 1 Hour 5 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("SAUSAGE MIXTURE")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient1"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¾")]), _vm._v(" lb bulk pork breakfast sausage")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" medium onion, chopped (½ cup)")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" can (4 oz) mushrooms pieces and stems, drained")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("3")]), _vm._v(" tablespoons chopped fresh sage leaves")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" cup shredded Cheddar cheese (4 oz)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingredient_head"
  }, [_vm._v("BAKING MIXTURE")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient1"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" cup Original Bisquick mix")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" cup milk")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("2")]), _vm._v(" eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" Heat oven to 375°F. Spray 12 regular-size muffin cups with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" In 10-inch skillet, cook sausage and onion over medium-high heat 5 to 7 minutes, stirring occasionally, until sausage is no longer pink; drain. Cool 5 minutes; stir in mushrooms, salt, sage and cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("3")]), _vm._v(" In medium bowl, stir baking mixture ingredients with whisk or fork until blended. Spoon slightly less than 1 tablespoon baking mixture into each muffin cup. Top each with about ¼ cup sausage mixture and 1 tablespoon baking mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("4")]), _vm._v(" Bake about 30 minutes or until toothpick inserted in center comes out clean and tops are golden brown. Cool 5 minutes. With thin knife, loosen sides of pies from pan; remove from pan and place top sides up on cooling rack. Cool 10 minutes longer before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("5")]), _vm._v(" To freeze, cool completely. Wrap tightly. Freeze up to 3 months. Thaw in refrigerator overnight. Unwrap; microwave 1 pie on High about 1 minute or until hot.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Serving:")]), _vm._v(" Calories 250; Total Fat 17g (Saturated Fat 8g, Trans Fat 0.5g); Cholesterol 105mg; Sodium 920mg; Total Carbohydrate 10g (Dietary Fiber 1g); Protein 14g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" ½ Starch, ½ Vegetable, 1½ High-Fat Meat, 1 Fat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" ½")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99367ff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p036.vue
// module id = 153
// module chunks = 0